module.exports = __webpack_public_path__ + "default.6bac3bc6ee29a1366aa1cfb2c132e4b7.svg";